import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-right",
  "use": "icon-right-usage",
  "viewBox": "0 0 72 72",
  "content": "<symbol viewBox=\"0 0 72 72\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-right\">\n<circle cx=\"36\" cy=\"36\" r=\"36\" fill=\"black\" fill-opacity=\"0.3\" />\n<path d=\"M27 36H45M45 36L35.8085 26M45 36L35.8085 46\" stroke=\"white\" stroke-width=\"2\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol